<ng-container>
    <div class="ppl-container-body">
        <div class="ppl-container-head">
            Resubmission Report
        </div>
        <div class="ppl-container">
            <div class="ppl-content-container report-container">
                <div style="width: 100%">
                    <ppl-report-filters (filterChanged)="filterChanged($event)" [filterFields]="filterFields"
                        [report]="'resubReport'"></ppl-report-filters>
                </div>
                @if (resubmissionReportData) {
                <div style="min-width: 50%;">
                    <ppl-list-table [disableSort]="true" [pageConfig]="programName" [disableSearch]="true"
                        [showCustomSearch]="false" [data]="resubmissionReportData" [disableSelection]="true"
                        [cols]="cols" [gridTitle]="false" [pagination]="true" [loadPage]="false" [enableActions]="false"
                        [customDataLoaded]="true">
                    </ppl-list-table>
                </div>
                }
            </div>
        </div>
    </div>
</ng-container>